import { Routes, Route, Navigate, useParams } from "react-router-dom";

// Layouts
import MarketingLayout from "../layouts/marketing/MarketingLayout.jsx";
import AuthLayout from "../layouts/auth/AuthLayout.jsx";
import DashboardLayout from "../layouts/dashboard/DashboardLayout.jsx";
import ProtectedRoute from "./ProtectedRoute.jsx";
import ApprovedFamilyRoute from "./ApprovedFamilyRoute.jsx";
import { useAuth } from "../AuthContext.jsx";
import { normalizeLocalType } from "../../utils/userTypes.js";

// Pages (serão importadas conforme forem migradas)
import HomePage from "../../features/marketing/home/HomePage.jsx";
import FamiliesPage from "../../features/marketing/families/FamiliesPage.jsx";
import BabysittersPage from "../../features/marketing/babysitters/BabysittersPage.jsx";

// Auth pages
import Login from "../../auth/Login.jsx";
import AuthOptionsPage from "../../features/auth/auth-options/AuthOptionsPage.jsx";
import ProfileSelectionPage from "../../features/auth/profile-selection/ProfileSelectionPage.jsx";
import CadastroBabysitter from "../../auth/CadastroBabysitter.jsx";
import CadastroFamilia from "../../auth/CadastroFamilia.jsx";
import RecuperarSenha from "../../auth/RecuperarSenha.jsx";
import ResetarSenha from "../../auth/ResetarSenha.jsx";
import VerificarEmailPage from "../../auth/VerificarEmailPage.jsx";
import AguardandoAprovacaoPage from "../../auth/AguardandoAprovacaoPage.jsx";

// Dashboard pages
import DashboardFamilyPage from "../../features/dashboard-family/overview/DashboardFamilyPage.jsx";
import DashboardBabysitter from "../../pages/DashboardBabysitter.jsx";
import DashboardAdmin from "../../pages/DashboardAdmin.jsx";

// Standalone pages
import BabaPerfil from "../../components/BabaPerfil.jsx";
import TodasAsBabasPage from "../../features/marketing/babas/TodasAsBabasPage.jsx";
import PrivacyPolicyScreen from "../../features/marketing/legal/PrivacyPolicyScreen.jsx";
import TermodeUso from "../../features/marketing/legal/TermodeUso.jsx";
import CheckoutPacotePage from "../../features/payment/checkout/CheckoutPacotePage.jsx";
import PagamentoPage from "../../features/payment/checkout/PagamentoPage.jsx";
import MeusPagamentosPage from "../../features/payment/history/MeusPagamentosPage.jsx";
import EscolherAssinaturaPage from "../../features/payment/subscription/EscolherAssinaturaPage.jsx";
import PagamentoStatus from "../../pages/PagamentoStatus.jsx";

// Redirect /perfil-novo → /cadastro-familia ou /cadastro-baba conforme tipo do usuário
function PerfilNovoRedirect() {
  const { userType } = useAuth();
  const tipo = normalizeLocalType(userType);

  if (tipo === "admin") return <Navigate to="/dashboard-admin" replace />;
  if (tipo === "babysitter") return <Navigate to="/cadastro-baba" replace />;
  return <Navigate to="/cadastro-familia" replace />;
}

function BabaPerfilAliasRedirect() {
  const { id } = useParams();
  return <Navigate to={`/perfil-baba/${id}`} replace />;
}

export default function AppRouter() {
  return (
    <Routes>
      {/* Marketing routes */}
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<HomePage />} />
        {/*<Route path="/familia" element={<FamiliesPage />} />*/}
        <Route path="/para-familias" element={<FamiliesPage />} />
        {/*<Route path="/baba" element={<BabysittersPage />} />*/}
        <Route path="/para-babas" element={<BabysittersPage />} />
        <Route
          path="/babas"
          element={
            <ApprovedFamilyRoute>
              <TodasAsBabasPage />
            </ApprovedFamilyRoute>
          }
        />
        <Route path="/baba/:id" element={<BabaPerfilAliasRedirect />} />
        <Route
          path="/perfil-baba/:id"
          element={
            <ApprovedFamilyRoute>
              <BabaPerfil />
            </ApprovedFamilyRoute>
          }
        />
        <Route path="/politica-de-privacidade" element={<PrivacyPolicyScreen />} />
        <Route path="/termos-de-uso" element={<TermodeUso />} />
      </Route>

      {/* Auth routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/auth-options" element={<AuthOptionsPage />} />
        <Route path="/auth" element={<AuthOptionsPage />} />
        <Route path="/profile-selection" element={<ProfileSelectionPage />} />
        <Route path="/recuperar-senha" element={<RecuperarSenha />} />
        <Route path="/resetar-senha" element={<ResetarSenha />} />
        <Route path="/verificar-email" element={<VerificarEmailPage />} />
        <Route path="/aguardando-aprovacao" element={<AguardandoAprovacaoPage />} />
      </Route>

      {/* Dashboard routes — protegidas, exigem sessão válida */}
      <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
        <Route path="/dashboard-familia" element={<DashboardFamilyPage />} />
        <Route path="/dashboard-baba" element={<DashboardBabysitter />} />
        <Route path="/dashboard-admin" element={<DashboardAdmin />} />
        <Route path="/checkout/pacote/:pacoteId" element={<CheckoutPacotePage />} />
        <Route path="/pagamento" element={<PagamentoPage />} />
        <Route path="/escolher-assinatura" element={<EscolherAssinaturaPage />} />
        <Route path="/meus-pagamentos" element={<MeusPagamentosPage />} />
      </Route>

      {/*
        Rotas de retorno do Mercado Pago — ficam FORA do ProtectedRoute para que o
        redirect do MP nunca caia em tela de login quando a sessão ainda está ativa.
        O componente PagamentoStatus verifica a sessão internamente para o RPC.
      */}
      <Route element={<DashboardLayout />}>
        <Route path="/pagamento/:status" element={<PagamentoStatus />} />
      </Route>

      {/* Cadastro routes (standalone, sem layout wrapper) */}
      <Route path="/cadastro-baba" element={<CadastroBabysitter />} />
      <Route path="/cadastro-familia" element={<CadastroFamilia />} />

      {/* Perfil novo — redireciona conforme tipo do usuário */}
      <Route path="/perfil-novo" element={<PerfilNovoRedirect />} />

    </Routes>
  );
}